/*
 * @Author: 赵健
 * @Date: 2021-01-14 10:51:47
 * @LastEditTime: 2021-01-18 15:13:19
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\store\getters.js
 */
const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name, // 用户名
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  userModule: state => state.user.userModule,
  businessLogo: state => state.user.businessLogo
}
export default getters
